//@flow
import { authenticatedFetch } from '../../../api/request';

const agreeToTermsOfUseOrRequestConsent = async (
    isMinor: boolean,
    parentGuardianEmail: string,
    dateOfBirth: string
) => {
    const path = '/v5/userAgreementTerms/agree';
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            isMinor,
            parentGuardianEmail,
            dateOfBirth
        })
    };
    return await authenticatedFetch(path, requestOptions);
};

export default agreeToTermsOfUseOrRequestConsent;
